<template>
  <div>
    <CandidateInterviewRecording v-if="showOfficeInterviewButtons" />
    <CandidateInterviewProcessing v-else-if="isOfficeInterviewProcessing" />
    <CandidateInterviewProcessingFailed v-else-if="isOfficeInterviewProcessingFailed" />
    <CandidateInterviewOffice
      v-else-if="showOfficeInterviewPlayer"
      v-model="officeInterviewPlayerTime"
      :interview="interview"
    />
  </div>
</template>

<script>
import { interviewStatuses } from '../../../enums';
import CandidateInterviewRecording from '../CandidateInterviewRecording.vue';
import CandidateInterviewProcessing from '../CandidateInterviewProcessing.vue';
import CandidateInterviewProcessingFailed from '../CandidateInterviewProcessingFailed.vue';
import CandidateInterviewOffice from '../CandidateInterviewOffice.vue';

export default {
  name: 'OfficeInterview',
  components: {
    CandidateInterviewRecording,
    CandidateInterviewProcessing,
    CandidateInterviewProcessingFailed,
    CandidateInterviewOffice,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    interview: {
      required: true,
    },
  },
  data() {
    return {
      officeInterviewDialog: false,
      officeInterviewRecording: false,
      officeInterviewRecorded: false,
      officeInterviewResume: false,
      officeInterviewOverwrite: false,
      officeInterviewPrepareLoading: false,
      showOfficeInterviewCloseButton: true,
    };
  },
  computed: {
    officeInterviewPlayerTime: {
      get() {
        return this.$store.state.candidatePage.officeInterviewPlayerTime;
      },
      set(value) {
        this.$store.commit('candidatePage/setOfficeInterviewPlayerTime', value);
      },
    },
    showOfficeInterviewPlayer() {
      return this.interview
        && this.interview.status === interviewStatuses.READY;
    },
    isOfficeInterviewProcessing() {
      return this.interview
        && this.interview.status === interviewStatuses.PROCESSING;
    },
    isOfficeInterviewProcessingFailed() {
      return this.interview
        && this.interview.status === interviewStatuses.PROCESSING_FAILED;
    },
    showOfficeInterviewButtons() {
      return this.interview
        && (this.interview.status === interviewStatuses.RECORDING
          || this.interview.status === interviewStatuses.BLANK);
    },
  },
  methods: {
    showOfficeInterviewDialog() {
      this.officeInterviewDialog = true;
    },
    overwriteOfficeInterview() {
      this.officeInterviewOverwrite = true;
      this.officeInterviewResume = false;
      this.showOfficeInterviewDialog();
    },
    resumeOfficeInterview() {
      this.officeInterviewOverwrite = false;
      this.officeInterviewResume = true;
      this.showOfficeInterviewDialog();
    },
    async saveOfficeInterview() {
      await this.withApiErrorHandling(async () => {
        await this.$store.dispatch('officeInterview/stopPublication', {
          id: this.candidate.officeInterview.id,
        });
      }, e => this.$toast.error(e.message), 'officeInterviewPrepareLoading');
    },
    interviewRecordingStarted() {
      this.officeInterviewRecording = true;
      this.showOfficeInterviewCloseButton = false;
    },
    interviewRecordingFinished() {
      this.officeInterviewDialog = false;
      this.officeInterviewRecording = false;
      this.officeInterviewRecorded = true;
      this.showOfficeInterviewCloseButton = true;
    },
    interviewRecordingError() {
      this.officeInterviewDialog = false;
      this.officeInterviewRecording = false;
      this.showOfficeInterviewCloseButton = true;
    },
    closeOfficeInterviewDialog() {
      this.officeInterviewDialog = false;
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
recordWasStopped: Recording was interrupted
chooseOption: Choose an option
resumeOfficeInterview: Continue recording
overwrite: Overwrite
save: Save
</i18n>

<i18n locale="ru" lang="yaml">
recordWasStopped: По какой-то причине запись была прервана
chooseOption: Выберите один из подходящих вариантов
resumeOfficeInterview: Продолжить запись
overwrite: Записать заново
save: Сохранить
</i18n>
